import type { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  description: ReactNode;
  /** 하단 CTA 버튼들. 폭은 화면별로 다르므로 호출부가 정한다. */
  actions: ReactNode;
};

/**
 * 404 · 500 등 전면 안내 화면의 공통 골격.
 *
 * 시안의 1024 ↔ 1025 분기가 디자인 시스템 `desktop` breakpoint(1024.02px) 와 같아
 * 두 축 모두 `desktop:` 하나로 나뉜다.
 * - 세로 정렬: 데스크톱은 남은 높이의 중앙, 그 미만은 상단에서 py-160 만큼 띄움
 * - 버튼 방향: 데스크톱 가로, 그 미만 세로
 */
export function ErrorPageSection({ title, description, actions }: Props) {
  return (
    <section className="desktop:justify-center flex flex-1 flex-col items-center gap-52 bg-gray-100 py-160">
      <div className="flex flex-col items-center gap-8 text-center">
        <h1 className="text-body-900 font-bold text-gray-900">{title}</h1>
        <p className="text-body-400 font-medium text-gray-800">{description}</p>
      </div>

      <div className="desktop:flex-row flex flex-col gap-12">{actions}</div>
    </section>
  );
}
